import React, { FC, useEffect, useState } from 'react'
import { Redirect, Switch, Route, useLocation } from 'react-router-dom'
import { shallowEqual, useSelector } from 'react-redux'
import { MasterLayout } from '../../_metronic/layout/MasterLayout'
import { PrivateRoutes } from './PrivateRoutes'
import { Logout, AuthPage } from '../modules/auth'
import { ErrorsPage } from '../modules/errors/ErrorsPage'
import { RootState } from '../../setup'

const Routes: FC = () => {
  const location = useLocation();  // Current location/path
  const accessTokenFromState = useSelector<RootState>(({ auth }) => auth.accessToken, shallowEqual);
  
  const [isAuthorized, setIsAuthorized] = useState<boolean>(false);

  // On page load, check if the user is authenticated
  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    if (token || accessTokenFromState) {
      setIsAuthorized(true);
    } else {
      setIsAuthorized(false);
    }
  }, [accessTokenFromState]);

  // Handle user redirection after login/refresh
  useEffect(() => {
    if (isAuthorized) {
      // If the user is authorized, save the current location to localStorage
      localStorage.setItem("lastVisitedPage", location.pathname);
    }
  }, [isAuthorized, location]);

  // Get the last visited page from localStorage or default to "/"
  const lastVisitedPage = localStorage.getItem("lastVisitedPage") || '/';

  return (
    <Switch>
      {/* Render Auth Page for unauthenticated users */}
      <Route path='/auth'>
        {!isAuthorized ? <AuthPage /> : <Redirect to={lastVisitedPage} />}
      </Route>

      {/* Render Logout */}
      <Route path='/logout'>
        <Logout />
      </Route>

      {/* Render Error Page */}
      <Route path='/error'>
        <ErrorsPage />
      </Route>

      {/* Render Private Routes for authenticated users */}
      {isAuthorized ? (
        <MasterLayout>
          <PrivateRoutes />
        </MasterLayout>
      ) : (
        <Redirect to='/auth/login' />
      )}
    </Switch>
  );
};

export { Routes };
